export default __webpack_public_path__ + "static/media/Datorsal7.3fa0de3b.jpeg";